import React from 'react';

const Coupons: React.FC = () => {
  return <div>Coupons Component</div>;
};

export default Coupons;
